var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgActiveCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80.4375L88.7308 36L81.0865 66.5508L103 70.5625L64.2692 115L71.7861 84.6035L50 80.4375Z",
    fill: "url(#paint0_linear_3967_295928)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3967_295928",
    x1: 76.5,
    y1: 36,
    x2: 76.5,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgActiveCustomer);
export default __webpack_public_path__ + "static/media/img_active_customer.49241340c18e72407d8c0ebfbabbc3bb.svg";
export { ForwardRef as ReactComponent };